import { Card } from "primereact/card";
import { Tooltip } from "primereact/tooltip";
import { formatGBP } from "../../leak detection/helper/helperFunctions";

// export const formatNumber = (amount: string): string => {
//   const num = parseFloat(amount.split("£")[1]);
//   if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
//   if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
//   if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";

//   return `£ ${num}`;
// };

const formatNumber = (amount: string): any => {
  if (!amount) return "0.00"; // Default to 0.00 if empty
  // Match amounts with currency symbols using regex
  const currencyPattern = /([£$€¥₹])\s?([\d,]+)/g;
  let formattedAmounts: string[] = [];

  let match;
  while ((match = currencyPattern.exec(amount)) !== null) {
    const symbol = match[1]; // Currency symbol
    const num = parseFloat(match[2].replace(/,/g, "")); // Remove commas and parse number

    let formattedValue;
    if (num >= 1_000_000_000) {
      formattedValue = (num / 1_000_000_000).toFixed(1) + "B";
    } else if (num >= 1_000_000) {
      formattedValue = (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      formattedValue = (num / 1_000).toFixed(1) + "K";
    } else {
      formattedValue = num.toString();
    }

    formattedAmounts.push(`${symbol} ${formattedValue}`);
  }

  return formattedAmounts.map((formattedAmount, index) => (
    <span key={index} className="tw-block">
      {formattedAmount}
    </span>
  ));
};

// const formatNumber = (amount: string): any => {
//   if (!amount) return "0.00"; // Default to 0.00 if empty

//   // Match amounts with or without currency symbols
//   const currencyPattern = /([£$€¥₹])?\s?([\d,]+(?:\.\d+)?)/g;
//   let formattedAmounts: string[] = [];

//   let match;
//   while ((match = currencyPattern.exec(amount)) !== null) {
//     const symbol = match[1] || ""; // Currency symbol (if present)
//     const numString = match[2]?.replace(/,/g, ""); // Remove commas

//     if (!numString) continue; // Prevent empty matches

//     const num = parseFloat(numString);
//     if (isNaN(num)) continue; // Ignore invalid numbers

//     let formattedValue;
//     if (num >= 1_000_000_000) {
//       formattedValue = (num / 1_000_000_000).toFixed(1) + "B";
//     } else if (num >= 1_000_000) {
//       formattedValue = (num / 1_000_000).toFixed(1) + "M";
//     } else if (num >= 1_000) {
//       formattedValue = (num / 1_000).toFixed(1) + "K";
//     } else {
//       formattedValue = num.toFixed(2); // Keep decimals for small numbers
//     }

//     formattedAmounts.push(symbol ? `${symbol} ${formattedValue}` : formattedValue);
//   }

//   return formattedAmounts.map((formattedAmount, index) => (
//     <span key={index} className="tw-block">
//       {formattedAmount}
//     </span>
//   ));
// };

const DashboardCard = ({ dashBoardData }: any) => {
  const header = (title: string) => (
    <p className="tw-text-black tw-font-medium tw-text-lg tw-text-center">
      {title}
    </p>
  );

  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-6 tw-w-full tw-mt-7 tw-mb-4">
      {/* Invoice Created */}
      <Tooltip
        target=".amount-tooltip"
        className="tw-whitespace-pre-line tw-text-center"
      />
      <Card
        className="widget-card tw-bg-red-500"
        header={header("Invoice Created")}
      >
        <div className="tw-grid tw-grid-cols-12 tw-gap-4">
          <div className="tw-col-span-6">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Total
              </p>
              <div className="tw-flex tw-flex-col tw-gap-0">
                <p className="tw-text-gray-500 tw-text-2xl tw-text-center">
                  {dashBoardData && dashBoardData.invoiceReport[0].invoicecount}
                </p>
              </div>
            </div>
          </div>
          <div className="tw-col-span-6">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Amount
              </p>

              <div className="tw-flex tw-flex-col tw-gap-0">
                <p
                  className="tw-text-green-500 tw-text-2xl tw-text-center amount-tooltip"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.invoiceReport[0]?.amount.split(",");

                    if (dashBoardData?.invoiceReport[0]?.amount.trim() === ",")
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                  // data-pr-at="bottom+5 bottom"
                  // data-pr-my="left center-2"
                  // style={{ fontSize: '2rem', cursor: 'pointer' }}>
                  // <Badge severity="danger"></Badge>
                >
                  {dashBoardData?.invoiceReport[0]?.amount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(dashBoardData?.invoiceReport[0]?.amount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card className="widget-card" header={header("Manager")}>
        <div className="tw-grid tw-grid-cols-8 tw-gap-4">
          {/* <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Approved
              </p>
              <div className="tw-flex tw-flex-col tw-gap-0">
                <p
                  className="tw-text-green-500 tw-text-2xl tw-text-center amount-tooltip"
                  data-pr-tooltip={`${
                    dashBoardData && dashBoardData.managerReport[0].approvedAmount}`}
                >
                  {dashBoardData?.managerReport[0]?.approvedAmount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(dashBoardData.managerReport[0].approvedAmount)}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData && dashBoardData.managerReport[0].approvedCount}
                </p>
              </div>
            </div>
          </div> */}
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Pending
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-yellow-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.managerReport[0].pendingAmount.split(",");

                    if (
                      dashBoardData?.managerReport[0].pendingAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData &&
                  dashBoardData.managerReport[0].pendingAmount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(
                        dashBoardData.managerReport[0].pendingAmount
                      )}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData && dashBoardData.managerReport[0].pendingCount}
                </p>
              </div>
            </div>
          </div>
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Rejected
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-red-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.managerReport[0].rejectedAmount.split(",");

                    if (
                      dashBoardData?.managerReport[0].rejectedAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData?.managerReport[0]?.rejectedAmount === ""
                    ? "0.00"
                    : formatNumber(
                        dashBoardData?.managerReport[0]?.rejectedAmount
                      )}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData &&
                    dashBoardData.managerReport[0].rejectedCount}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card className="widget-card" header={header("Senior Manager")}>
        <div className="tw-grid tw-grid-cols-8 tw-gap-4">
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Pending
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-yellow-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.seniorManagerReport[0].pendingAmount.split(
                        ","
                      );

                    if (
                      dashBoardData?.seniorManagerReport[0].pendingAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData &&
                  dashBoardData.seniorManagerReport[0].pendingAmount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(
                        dashBoardData.seniorManagerReport[0].pendingAmount
                      )}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData &&
                    dashBoardData.seniorManagerReport[0].pendingCount}
                </p>
              </div>
            </div>
          </div>
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Rejected
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-red-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.seniorManagerReport[0].rejectedAmount.split(
                        ","
                      );

                    if (
                      dashBoardData?.seniorManagerReport[0].rejectedAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData?.seniorManagerReport[0]?.rejectedAmount === ""
                    ? "0.00"
                    : formatNumber(
                        dashBoardData?.seniorManagerReport[0]?.rejectedAmount
                      )}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData &&
                    dashBoardData.seniorManagerReport[0].rejectedCount}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card className="widget-card" header={header("Director")}>
        <div className="tw-grid tw-grid-cols-8 tw-gap-4">
          {/* <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Approved
              </p>
              <div className="tw-flex tw-flex-col tw-gap-0">
                <p
                  className="tw-text-green-500 tw-text-2xl tw-text-center amount-tooltip"
                  data-pr-tooltip={`${
                    dashBoardData && dashBoardData.directorReport[0].approvedAmount
                  }`}
                >
                  {dashBoardData &&
                  dashBoardData.directorReport[0].approvedAmount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(dashBoardData.directorReport[0].approvedAmount)}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData && dashBoardData.directorReport[0].approvedCount}
                </p>
              </div>
            </div>
          </div> */}
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Pending
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-yellow-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.directorReport[0].pendingAmount.split(",");

                    if (
                      dashBoardData?.directorReport[0].pendingAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData &&
                  dashBoardData.directorReport[0].pendingAmount === ""
                    ? "0.00"
                    : dashBoardData &&
                      formatNumber(
                        dashBoardData.directorReport[0].pendingAmount
                      )}
                </p>
                <p className="tw-text-gray-500 tw-text-center">
                  {dashBoardData &&
                    dashBoardData.directorReport[0].pendingCount}
                </p>
              </div>
            </div>
          </div>
          <div className="tw-col-span-4">
            <div className="tw-flex tw-flex-col tw-justify-start">
              <p className="tw-text-black tw-font-medium tw-text-base tw-text-center">
                Rejected
              </p>
              <div className="tw-grid tw-grid-rows-2">
                <p
                  className="tw-text-red-500 tw-text-2xl tw-text-center amount-tooltip tw-grid tw-grid-rows-2"
                  data-pr-tooltip={(() => {
                    const amount =
                      dashBoardData?.directorReport[0].rejectedAmount.split(
                        ","
                      );

                    if (
                      dashBoardData?.directorReport[0].rejectedAmount.trim() ===
                      ","
                    )
                      return "0";
                    const joinedAmount = amount
                      .filter((val: any) => val.trim() !== "")
                      .join(",");
                    return joinedAmount
                      .split(",")
                      .map(
                        (joinedAmount: any, index: number) =>
                          `${
                            index === 0
                              ? joinedAmount.slice(0, 1)
                              : joinedAmount.slice(1, 2)
                          } ${formatGBP(joinedAmount.trim().slice(1))}`
                      )
                      .join(", ");
                  })()}
                  data-pr-position="bottom"
                >
                  {dashBoardData?.directorReport[0].rejectedAmount === ""
                    ? "0.00"
                    : formatNumber(
                        dashBoardData.directorReport[0].rejectedAmount
                      )}
                </p>

                <p className="tw-text-gray-500 tw-text-center tw-max-h-5">
                  {dashBoardData &&
                    dashBoardData.directorReport[0].rejectedCount}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DashboardCard;
